@if (display) {
  <p-dialog  header="{{title}}" [(visible)]="display"
    [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'" [modal]="true" [draggable]="false" [resizable]="false"
    [closeOnEscape]="false"
    [style]="{width: '80vw'}">
    <!--==== SELECCIÓ CARPETA ORIGEN ============================-->
    <div class="d-flex flex-column gap-3 p-3">
      <p-card class="w-100">
        <div class="d-flex row-cols-1 w-100">
          <div class="d-flex ps-3 align-items-center">
            <div class="d-flex flex-column mb-3">
              <div class="p-2 align-items-center">
                <!--[align]="'cols-2'"-->
                <form-input
                  [required]="true"
                  [align]="'cols-2'"
                  fieldName="{{ 'general.selectFolder' | translate }}"
                  >
                  <input
                    pInputText
                    [disabled]="false"
                    [readonly]="true"
                    [ngModel]="folder ? folder.name : null"
                    [style]="{ width: '500px', 'margin-right': '5px'}"
                    />
                  <button
                    id="uploadDocumentButton"
                    class="btn btn-outline-dark"
                    (click)="uploadDocumentInput.click()"
                    [disabled]="selectedSourceType === '' || selectedSourceType === null || !isDownloadGranted "
                    >
                    ...
                  </button>
                  <input
                    #uploadDocumentInput
                    [hidden]="true"
                    type="file"
                    webkitdirectory
                    (change)="changeFolder($event)"
                    />
                <!--</form-input>-->
                <br/>
                <app-table-excel-button class="buttonTableExcel" style="margin-left:10px;width:'32px';height:'32px'" (btnClick)="exportExcel()"></app-table-excel-button>
              </form-input>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
  <div class="d-flex flex-column gap-3 p-3">
    @if (previewReady && loadedEntity && loadedExcel && previewSpinner) {
      <div class="d-flex flex-column gap-3 p-3">
        <div class="d-flex row-cols-1 w-100">
          <div class="d-flex ps-3 align-items-center">
            {{ 'general.loading' | translate }}
          </div>
        </div>
      </div>
    }
    <p-table id="dt" [value]="files" [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'" class="custom-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="text-align: left;width:35%">{{ 'general.name' | translate }}</th>
          <th  style="text-align: center;width:10%">{{ 'general.processed' | translate }}</th>
          <th  style="text-align: center;width:10%">{{ 'general.correct' | translate }}</th>
          <th  style="text-align: left;width:55%">{{ 'general.observations' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file>
        <tr [ngStyle]="{
			'background-color': file.correct == false && file.processed == true ? '#ff7b5a' : 'inherit',
			'color': file.correct == true && file.processed == true ? 'green' : 'inherit'
		  }">
          <td>{{ file.name }}</td>
          <td style="text-align: center;">
            <p-checkbox
              [binary]="true"
              [disabled]="true"
              [ngModel]="file.processed">
            </p-checkbox>
          </td>
          <td style="text-align: center;">
            <p-checkbox
              [binary]="true"
              [disabled]="true"
              [ngModel]="file.correct">
            </p-checkbox>
          </td>
          <td>{{ file.message }}</td>
        </tr>
      </ng-template>
      <!-- TABLE EMPTY MESSAGE -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td  class="p-0" colspan="4">
            <div
              class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-orders-message"
              i18n
              >
                        {{ 'table.tableEmptyMessage' | translate }}!
                    </div>
          </td>
        </tr>
      </ng-template>
      <!-- FOOTER -->
      <ng-template pTemplate="footer">
        <tr>
          <td class="p-0" colspan="4">
            <div class="d-flex justify-content-between bd-highlight">
              <div class="p-2 bd-highlight">
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="process()"
                  [disabled]="disabledgenerate || generateSpinner|| !isDownloadGranted "
                  >
                  {{buttongenerate}}
                </button>
                @if (generateSpinner) {
                  <span [style]="{ 'margin-left': '20px' }">{{ 'general.wait2' | translate }}: {{processedCount}} {{ 'general.to' | translate }} {{files.length}} </span>
                }
              </div>
            </div>
          </td>
          <!-- <td class ="p-0" colspan ="3">
          <app-table-excel-button class="buttonTableExcel"
          (btnClick)="exportExcel()"></app-table-excel-button>
        </td> -->
      </tr>
    </ng-template>
  </p-table>
</div>
</p-dialog>
}